import {
  ACTION_ORDER_XCARD__REQUEST,
  ACTION_ORDER_XCARD__SUCCESS,
  ACTION_ORDER_XCARD__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_ORDER_XCARD__REQUEST:
    case ACTION_ORDER_XCARD__SUCCESS:
      return null;

    case ACTION_ORDER_XCARD__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
